import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.globalError)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["global-error", { 'show-global-error': _ctx.globalError }])
      }, [
        _createElementVNode("div", {
          class: "global-error__content",
          innerHTML: _ctx.globalError
        }, null, 8, _hoisted_1)
      ], 2))
    : _createCommentVNode("", true)
}